<script lang="ts" setup>
import { ApiUrls } from '../types/base'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip'
defineProps<{
  missingPermissions: ApiUrls<any>['permissions']
  isAction?: boolean
}>()
</script>
<template>
  <TooltipProvider>
    <Tooltip>
      <TooltipTrigger as-child>
        <slot />
      </TooltipTrigger>
      <TooltipContent>
        <b
          >Missing necessary permissions to
          {{ isAction ? 'perform this action.' : 'view this data.' }}</b
        >
        <p>Permitted roles: "{{ missingPermissions.join('", "') }}"</p>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
</template>
